// ============================================================
// 异步任务轮询通用类型
// 触发类接口（同步渠道 / 同步 SKU / 同步库存等）返回 taskId 后，
// 由 @shared/store/modules/asyncTask 负责轮询 /{manage|customer}/asyncTask/batchDetail
// ============================================================

/** 任务状态：1 待处理 2 执行中 3 成功 4 失败 */
export enum AsyncTaskStatus {
    Pending = 1,
    Running = 2,
    Success = 3,
    Failed = 4,
}

/**
 * 与后端约定的任务类型。
 * 导出全站共用同一 taskType，业务差异用 batchDetail.taskTypeLabel 展示（如「产品导出」「品牌导出」）。
 */
export const ASYNC_TASK_TYPE = {
    Export: "EXPORT",
} as const;

/** POST /{manage|customer}/asyncTask/batchDetail 返回的单条任务详情 */
export interface AsyncTaskDetail<TResult = Record<string, any>> {
    taskId: string;
    taskType: string;
    taskTypeLabel: string;
    targetType: string;
    targetId: string;
    status: AsyncTaskStatus;
    statusLabel: string;
    paramsJson: Record<string, any>;
    resultJson: TResult | null;
    errorMessage: string;
    operatorId: string;
    operatorName: string;
    startTimeLabel: string;
    finishTimeLabel: string;
    createTimeLabel: string;
}

/** 渲染通知 / 跳转所需的业务上下文；只能是可序列化的原始值（要落 localStorage） */
export interface AsyncTaskContext {
    [key: string]: string | number | boolean | null | undefined;
}

/** active 快轮询队列（localStorage: asyncTasks:active）里的一条记录 */
export interface ActiveAsyncTask {
    taskId: string;
    taskType: string;
    context: AsyncTaskContext;
    userId?: string;
    /** 最近一次 batchDetail 拿到的展示名；2h 放弃时用此拼失败文案 */
    taskTypeLabel?: string;
    /** 任务触发时间，仅展示/日志用 */
    createdAt: number;
    /** 进入 active 队列的时间，active 窗口从这个时间起算 */
    activeEnteredAt: number;
}

/** waiting 慢速抽查队列（localStorage: asyncTasks:waiting）里的一条记录 */
export interface WaitingAsyncTask {
    taskId: string;
    taskType: string;
    context: AsyncTaskContext;
    userId?: string;
    /** 最近一次 batchDetail 拿到的展示名；2h 放弃时用此拼失败文案 */
    taskTypeLabel?: string;
    createdAt: number;
    /** 进入 waiting 队列的时间，最长保留时间从这个时间起算 */
    enteredWaitingAt: number;
    /** 最近一次真正发起抽查请求的时间，抽查间隔从这个时间起算 */
    lastCheckedAt: number;
}
